/*
 * Copyright 2022 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { createTemplateAction } from '@backstage/plugin-scaffolder-node';

export function createSerializeJsonAction() {
  return createTemplateAction({
    id: 'roadiehq:utils:serialize:json',
    description: 'Allows performing serialization on an object',
    supportsDryRun: true,
    schema: {
      input: {
        data: z =>
          z.record(z.any()).describe('Input data to perform serialization on.'),
        replacer: z =>
          z.array(z.string()).describe('Replacer array').optional(),
        space: z => z.string().describe('Space character').optional(),
      },
      output: {
        serialized: z =>
          z.string().describe('Output result from serialization').optional(),
      },
    },

    async handler(ctx) {
      ctx.output(
        'serialized',
        JSON.stringify(
          ctx.input.data,
          ctx.input.replacer?.length ? ctx.input.replacer : null,
          ctx.input.space,
        ),
      );
    },
  });
}
